/** How often a repeating task comes round: every `repeatInterval` of these. */
export const TASK_REPEAT_UNITS = ['DAY', 'WEEK', 'MONTH'];
/** The longest gap a repeat may have, in its own unit. */
export const MAX_TASK_REPEAT_INTERVAL = 365;
export const TASK_DUE_BUCKETS = [
    'overdue',
    'today',
    'week',
    'later',
    'none',
];
export const TASK_DUE_BUCKET_LABELS = {
    overdue: 'Overdue',
    today: 'Today',
    week: 'Next 7 days',
    later: 'Later',
    none: 'No date',
};
//# sourceMappingURL=event-ops.js.map